import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Switch, Route, useHistory, useLocation, useParams } from 'react-router';
import { RootState } from 'store/types';
import { serviceLoading } from 'common/loaderReducer';
import { POST_DEALER_CACHE_SYNC_API_REQUEST } from 'features/Dealers/DealerConfiguration/state/actionTypes';
import Loader from 'components/Loader';
import { TCButton } from 'components/TCButton';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';
import Listing from 'features/Dealers/Listings';
import { editCurrentSelectedListing, getListingsForDealer } from 'features/Dealers/Listings/state/actions';
import { ListingType } from 'features/Dealers/Listings/state/types';
import { postDealerCacheSync } from 'features/Dealers/DealerConfiguration/state/actions';
import { MainContainer, TabBody, HalfSection, SeparatorH, AlertContainer, AlertBox, AlertMessage, Title, TitleContainer, AlertButtonContainer, Close } from './styles';
import { SeparatorBoxes, VSeparatorContainer } from './styles';
import GMBPreview from '../Listings/GMBPreview';
import { SIZE } from 'common/sizes';
import { ReactComponent as ExIcon } from 'common/images/search_ex.svg'
import { isFunction } from 'lodash';
import {disconnectDealerToEngineAPI} from 'features/Dealers/ConnectByLabel/state/actions'
import ModalDisconnect from 'features/Home/Modals/ModalDisconnect'
//import ModalSync from 'features/Home/Modals/ModelSync'
import { DISCONNECT_DEALER_TO_ENGINE_API_REQUEST } from 'features/Dealers/ConnectByLabel/state/actionTypes';
import { connected } from 'process';
import ModalPush from './Modals/ModalPush'
import { publishAPI, publishCleanResult } from './Modals/ModalPush/state/actions';
import { getLastSyncDateAPI, syncEngineDealerAPI, unsyncEngineDealerAPI } from '../state/actions';
import { PUBLISH_API_REQUEST } from './Modals/ModalPush/state/actionTypes';
import AlertIcon from 'common/icons/alertIcon';
import { getEnginePerPackage } from 'common/utils';
import { SYNC_DEALER_API_REQUEST } from 'features/Dealers/state/actionTypes';

const ListingConfiguration = (props: any) => {
    const history = useHistory();
    const location = useLocation();
    const [showAlert, setShowAlert] = React.useState(true);
    const [canRenderContent, setCanRenderContent] = React.useState(false);  
    const [showSyncModal, setShowSyncModal] = React.useState(false);
    const [showDisconnectModal, setShowDisconnectModal] = React.useState(false);
    const [isConnected, setIsConnected] = React.useState(false);
    const [isSynced, setIsSynced] = React.useState(false);
    const [fields, setFields] = React.useState(["Phone", "URLs"])
    const [triggerPublish, setTriggerPublish] = React.useState<boolean>(false);
    const [isSyncingOrPublishing, setIsSyncingOrPublishing] = React.useState<boolean>(false);

    const dispatch = useDispatch();
    const deparmentId = props.match.params.id;

    const {
        selectedDealer,
        isCacheSyncing,
        isPublishSyncing,
        isDisconnectSyncing,
        publishSyncResult,
        listingsByDealerId,
        liveDepartments,
        locations,
        engineDealer,
        listingDealer,
        user,
        connect,
        isSyncingDealer,       
        listingsChanges
    } = useSelector((rootState: RootState) => {
        return {
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            isCacheSyncing: serviceLoading(rootState, [POST_DEALER_CACHE_SYNC_API_REQUEST]),        
            isPublishSyncing: serviceLoading(rootState, [PUBLISH_API_REQUEST]),
            isDisconnectSyncing: serviceLoading(rootState, [DISCONNECT_DEALER_TO_ENGINE_API_REQUEST]),
            publishSyncResult: rootState.dealers.modelSync.publishResult,
            listingsByDealerId: rootState.dealers.listing.listings.byDealerId,
            liveDepartments: rootState.dealers.departments.liveDepartments,
            locations: rootState.dealers.departments.engineLocations,
            engineDealer: rootState.dealers.enginedealer.enginedealer,
            listingDealer: rootState.dealers.enginedealer.listingdealer,
            user:rootState.security.user,
            connect: rootState.dealers.connectByLabel.connect,
            isSyncingDealer: serviceLoading(rootState, [SYNC_DEALER_API_REQUEST]),            
            listingsChanges: rootState.dealers.listing.listings.listingsChanges
        }
    }, shallowEqual)


    const { listingId, listingName } = React.useMemo(() => {
        let listingId;
        let idInSource;
        let listingName;
        if (selectedDealer && listingsByDealerId[selectedDealer?.id]) {
            if (deparmentId!=undefined)
            {
                const departmentListing = listingsByDealerId[selectedDealer.id].find(listing => listing.type == ListingType.DEPARTMENT && listing.deparmentId==deparmentId);
                listingId = departmentListing?.id
                idInSource = departmentListing?.idInSource
            }
            else
            {
                const primaryListing = listingsByDealerId[selectedDealer.id].find(listing => listing.type = ListingType.PRIMARY);
                listingId = primaryListing?.id
                idInSource = primaryListing?.idInSource
            }

            const location = locations?.locations.find(f=> f.locationId == idInSource);
            listingName = location?.locationName;


        }
        return {
            listingId,listingName
        }

    }, [selectedDealer, listingsByDealerId, deparmentId, locations])

    React.useEffect(()=>{
        if (!isSyncingDealer && triggerPublish) {
            const engineId = getEnginePerPackage(selectedDealer?.lmPackage); 
            dispatch(publishAPI(engineId, selectedDealer?.id, "SL")); 
            setTriggerPublish(false);
        }
    },[isSyncingDealer])

    React.useEffect(()=>{
        if (!isPublishSyncing && isSyncingOrPublishing) {
            setIsSyncingOrPublishing(false);
        }
    },[isPublishSyncing])

    React.useEffect(() => {
        setIsSynced(listingDealer?.statusSync=="SYNCED")       
    }, [selectedDealer, listingDealer]);

    React.useEffect(() => {
        if (listingId && !isCacheSyncing) {
            dispatch(editCurrentSelectedListing(listingId))
            setCanRenderContent(true)
        }
    }, [isCacheSyncing, listingId])


    React.useEffect(() => {
        if (listingId) {
            dispatch(postDealerCacheSync(listingId))
        }
    }, [listingId])

    React.useEffect(() => {
        if (connect)
        {
            setIsConnected(connect?.connected)
            setShowDisconnectModal(connect?.connected); //Close automatically modal when disconnet finished
            window.location.reload();                
        }
    }, [connect]);

    if (!selectedDealer || isCacheSyncing || !canRenderContent || !listingId) {
        return (<Loader />);
    }

    return (
        <>
        <MainContainer>
            <AlertContainer>
            {
                showAlert && renderAlert()
            }
            </AlertContainer>
            
            <TabBody>
            <SeparatorBoxes/>
            <HalfSection>
                <Listing />
            </HalfSection>
            <SeparatorBoxes/>
            <VSeparatorContainer>
                <SeparatorH />
            </VSeparatorContainer>
            <SeparatorBoxes/>
            <HalfSection>
                <GMBPreview />
            </HalfSection>
            <SeparatorBoxes/>
            </TabBody>


            <ModalPush
                    onSyncConfirmed={() =>  {                                    
                        setIsSyncingOrPublishing(true);                                
                        setTriggerPublish(true);
                        const engineId = getEnginePerPackage(selectedDealer?.lmPackage); 
                        dispatch(syncEngineDealerAPI(engineId, selectedDealer!.id));
                    }}
                    onCancel={() => {
                        setIsSynced(false)
                        setShowSyncModal(false)}}
                    shouldShow={showSyncModal}
                    onOKClose={() => {
                        setShowSyncModal(false);
                        if (publishSyncResult != undefined) {
                            window.location.reload();
                        }
                    }}
                    isSyncing={isSyncingOrPublishing}
                    errorMessage={publishSyncResult?.message}
                    modal={modal()}
                    package={selectedDealer?.lmPackage}
                    listingsChanges={listingsChanges}
                />
                  
        </MainContainer>        
        <ModalDisconnect
          onDisconnectConfirmed={() =>  {              
              dispatch(disconnectDealerToEngineAPI("GMB",selectedDealer!.id))              
          }}
          onCancel={() => {
            setIsConnected(true)
            setShowDisconnectModal(false)}}
          shouldShow={showDisconnectModal}
          onOKClose={() => {
              setShowDisconnectModal(false);          
          }}
          isSyncing={isDisconnectSyncing}          
        />
      </>
               
    )

    
    function syncPublishErrorMessage() {
        if (publishSyncResult != undefined && publishSyncResult?.type != "SUCCESS") {
            return 'Error: ' + publishSyncResult?.message;
        }
        return undefined;
    }

    function syncPublishSucessMessage() {
        if (publishSyncResult != undefined && publishSyncResult?.type == "SUCCESS") {
            return publishSyncResult?.message;
        }
        return undefined;
    }
    function renderAlert()
    {

        let synced ="";
        if (selectedDealer && listingsByDealerId)
        {
            if (listingsByDealerId[selectedDealer.id]) 
            {
                let engine = selectedDealer.lmPackage && selectedDealer?.lmPackage=="ELITE"?"CHATMETER":"GMB"
                const primaryListing = listingsByDealerId[selectedDealer.id].find(listing => listing.type == ListingType.PRIMARY && listing.engineId==engine);
                if (primaryListing)
                    synced = primaryListing.statusSync  
            }
        }       
        
            //if (engineDealer?.statusSync=="NOTSYNCED" || engineDealer?.statusSync==null)
            if (synced=="NOTSYNCED" || synced=="" || synced==null)
            {
                if (user?.role != "DealerUser")
                {
                    return (
                        <AlertBox>
                        <AlertIcon fillColor='#a5a5a5' />
                        <AlertMessage>
                                The automatic sync is disabled.
                        </AlertMessage>
                        <AlertButtonContainer margin={`0 0 0 ${SIZE.ONE}px`} >
                            <TCButton
                                type={TC_BUTTON_TYPE.PRIMARY}
                                disabled={false}
                                onClick={() => {setShowDisconnectModal(true)}}
                                loading={false}
                                backgroudColor={'#ff7319'}
                            >
                                DISCONNECT DEALER
                            </TCButton>
                        </AlertButtonContainer>
                        <Close>
                            <ExIcon onClick={() => {setShowAlert(false)}}/>
                        </Close>
                        </AlertBox>    
                    )
                }
            }
            else
            {
                if (listingsChanges && listingsChanges?.changedListingsInfo && listingsChanges.changedListingsInfo.length>0)
                {
                    return (
                    <AlertBox>
                    <AlertIcon fillColor='#a5a5a5' />
                    <AlertMessage>
                            You've made changes in the Listing information. This information will be automatically pushed to Google Business Profile the next time
                            Listings Manager performs a sync.
                            If you'd like to push your changes now, press the button to the right. 
                            Keep in mind, by pressing
                            the button, you'll be pushing information for the primary listing and departments.
                    </AlertMessage>
                    <AlertButtonContainer margin={`0 0 0 ${SIZE.ONE}px`} >
                        <TCButton
                            type={TC_BUTTON_TYPE.PRIMARY}
                            disabled={false}
                            onClick={() => { setShowSyncModal(true)}}
                            loading={false}
                            backgroudColor={'#ff7319'}
                        >
                        PUSH CHANGES
                        </TCButton>
                    </AlertButtonContainer>
                    <Close>
                        <ExIcon onClick={() => {setShowAlert(false)}}/>
                    </Close>
                    </AlertBox>    
                    )
                }
            }
    }

    

    function modal(): string {
        if (publishSyncResult != undefined && publishSyncResult?.type == "SUCCESS") {
            if (selectedDealer && selectedDealer.lmPackage && selectedDealer.lmPackage == "ELITE")
                return 'successelite';
            else
                return 'success';
        }
        if (publishSyncResult != undefined && publishSyncResult?.type == "SUCCESSWITHERRORS") {
            return 'partial';
        }
        if (publishSyncResult != undefined && publishSyncResult?.type == "ERROR") {
            if (selectedDealer && selectedDealer.lmPackage && selectedDealer.lmPackage == "ELITE")
                return "notSyncedelite"
            else
                return 'notSynced';
        }
        return '';
    }

}

export default ListingConfiguration;